import { AdviceFilter } from "../../../../../custom_api/bookarang/types";
import React = require("react");
import { AdviceLayoutProps } from "../AdviceState";

type FilterUpdater = AdviceLayoutProps["updateFilterValue"]

export const Filters = (props: { filters: AdviceFilter[], updateFilterValue: FilterUpdater }) => {
  const { filters, updateFilterValue } = props

  return <>
    {filters.map(filter =>
      filter.metadata.feature_type == 'float' ? <FloatFilter key={`filter_${filter.id}`} {...{ filter, updateFilterValue }} />
        : <></>
    )}
  </>
}

const FloatFilter = (props: { filter: AdviceFilter, updateFilterValue: FilterUpdater }) => {
  const { filter: { id, name, metadata: { value, min_value, max_value, min_label, max_label } }, updateFilterValue } = props

  return <div className="layout__group">
    <label className="layout__title title--xs" htmlFor={name}>{name}</label>
    <input
      className="form__range"
      id={name}
      value={value}
      type="range"
      min={min_value}
      max={max_value}
      step={0.05}
      onChange={(e) => updateFilterValue(id, name, e.target.valueAsNumber)}
      autoComplete="on"
    />
    <div className="layout__range">
      <span className="range__label range__label--min">{min_label}</span>
      <span className="range__label range__label--min">{max_label}</span>
    </div>
  </div>
}
